module.exports = __webpack_public_path__ + "static/media/KPMG.de106d29.png";